import React, { useLayoutEffect, useMemo } from 'react';
import { useStore } from 'zustand';

import { faqsPropertyListService } from '@mygpt/app/faqs-property/services';
import { faqsPropertyStore } from '@mygpt/app/faqs-property/store';

export const useFAQsPropertyAll = (datasetId: string, autoLoad = false) => {
  const [loading, setLoading] = React.useState(autoLoad);

  const store = useStore(faqsPropertyStore);
  const data = useMemo(() => store.all[datasetId] ?? [], [store.all, datasetId]);
  const loadAll = React.useCallback(
    async (params: Omit<Parameters<typeof faqsPropertyListService>[0], 'datasetId'>) => {
      setLoading(true);
      return faqsPropertyListService({ datasetId, size: 1000, ...params })
        .then((res) => {
          faqsPropertyStore.setState({
            all: {
              [datasetId]: res.data.items,
            },
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [datasetId]
  );

  useLayoutEffect(() => {
    if (datasetId && autoLoad) loadAll({ page: 1 });
    else setLoading(false);
  }, [datasetId, autoLoad, loadAll]);

  return {
    loading,
    data,
    loadAll,
  };
};
